export default "__VITE_ASSET__DYDI3dhi__"